import { Prominences } from '@sede-enterprise/shell-ds-fabrics';
import {
  Option,
  Select,
  Sizes,
  Text,
} from '@sede-enterprise/shell-ds-react-framework';
import { SiteAvailabilityControl } from '@see-power-pft-common-js/net-availability/enums/site-availability-control';
import {
  assetAvailabilityReasonDetails,
  siteAvailabilityReasonDetails,
} from 'pages/Availability/common/FormDrawer/constants';
import { AvailabilityReasonDetail } from 'pages/Availability/common/FormDrawer/types';

interface ReasonSelectProps {
  value: any;
  disabled: boolean;
  onChange: (value: any) => void;
  availabilityControl?: SiteAvailabilityControl;
  testId?: string;
  placeholder?: string;
  helper?: { content: string; sentiment: any } | undefined;
}

export const ReasonSelect = ({
  value,
  disabled,
  onChange,
  availabilityControl = SiteAvailabilityControl.SiteLevel,
  testId = 'reductionFormReason',
  placeholder = 'Why your availability is changing...',
}: ReasonSelectProps) => {
  const reasonDetails =
    availabilityControl === SiteAvailabilityControl.AssetLevel
      ? assetAvailabilityReasonDetails
      : siteAvailabilityReasonDetails;

  return (
    <Select
      data-testid={testId}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      optionLabelProp="label"
      optionFilterProp="label"
      disabled={disabled}
      dropdownAlign={{
        points: ['tl', 'bl'],
        overflow: { adjustX: true, adjustY: false },
      }}
    >
      {reasonDetails.map((reason: AvailabilityReasonDetail) => (
        <Option key={reason.id} value={reason.id} label={reason.title}>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <Text>{reason.title}</Text>
            <Text size={Sizes.Small} prominence={Prominences.Subtle}>
              {reason.description}
            </Text>
          </div>
        </Option>
      ))}
    </Select>
  );
};
